import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import Collapse from '@mui/material/Collapse'

import ClickAwayListener from '@mui/base/ClickAwayListener'

import AdxButton from 'components/custom/AdxButton'

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const navigate = useNavigate()

  const handleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleSignIn = () => {
    window.scrollTo(0, 0)
    navigate('/login')
  }

  const handleSignUp = () => {
    window.scrollTo(0, 0)
    navigate('/signup')
  }

  const goToTop = () => {
    window.scrollTo(0, 0)
    navigate('/')
  }

  return (
    <ClickAwayListener onClickAway={() => setIsMenuOpen(false)}>
      <Box
        component={'header'}
        sx={{
          height: { xs: '60px', md: '80px' },
          borderBottom: '1px solid #E5E5E5',
          position: 'sticky',
          top: 0,
          backdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(255,255,255,0.8)',
          zIndex: 1100,
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            height: '100%',
          }}
        >
          <Stack
            direction={'row'}
            justifyContent="space-between"
            alignItems={'center'}
            height="100%"
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            <Box
              component="img"
              src={'/adnexio-logo-text.svg'}
              alt="adnexio logo"
              onClick={goToTop}
              sx={{ cursor: 'pointer', width: 140 }}
            />
            <Stack direction={'row'} spacing={1}>
              <AdxButton size={'small'} onClick={handleSignUp}>
                Sign up
              </AdxButton>
              <AdxButton variant={'outlined'} size={'small'} onClick={handleSignIn}>
                Sign in
              </AdxButton>
            </Stack>
          </Stack>
          <Stack
            justifyContent="center"
            alignItems="flex-start"
            sx={{ display: { md: 'none', height: '100%' } }}
          >
            <IconButton size="large" onClick={handleMenu}>
              {isMenuOpen && <CloseRoundedIcon fontSize="inherit" color="dark-text" />}
              {!isMenuOpen && <MenuRoundedIcon fontSize="inherit" color="dark-text" />}
            </IconButton>
            <Box
              component="img"
              src={'/adnexio-logo-text.svg'}
              alt="adnexio logo"
              sx={{
                position: 'absolute',
                left: '50%',
                transform: 'translate(-50%,0)',
                height: '20px',
                cursor: 'pointer',
              }}
              onClick={goToTop}
            />
          </Stack>
        </Container>
        <Collapse
          in={isMenuOpen}
          sx={{
            position: 'absolute',
            top: '60px',
            backgroundColor: 'rgba(255,255,255)',
            width: '100%',
            zIndex: 1100,
            boxShadow: 'rgb(170 180 190 / 30%) 0px 4px 20px',
            display: { md: 'none' },
          }}
        >
          <Container
            maxWidth="lg"
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              py: 1,
              gap: 1,
            }}
          >
            <AdxButton variant={'contained'} sx={{ width: 1 }} onClick={handleSignUp}>
              Sign up
            </AdxButton>

            <AdxButton variant={'ghost'} sx={{ width: 1 }} onClick={handleSignIn}>
              Sign in
            </AdxButton>
          </Container>
        </Collapse>
      </Box>
    </ClickAwayListener>
  )
}

export default NavBar
